import React, { useState, useEffect, useRef } from 'react';
import { getEnv } from '@ywfe/utils';
import styled from 'styled-components';

const IconStyle = styled.div`
  height: 0;
  .img-container {
    cursor: pointer;
    z-index: 1031;
    position: fixed;
    right: -50px;
    bottom: 20vh;
    &:hover {
      right: 0px;
    }
  }
`

function AiChatExit(props) {
  const dragRef = useRef(null);
  const dropMoveRef = useRef(null);
  const { hiddenPages, top = 650 } = props;
  const [isHidden, setIsHidden] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [topVal, setTopVal] = useState<number | string | null>(top || null);

  useEffect(() => {
    // 全局挂挂载函数调用
    let isHiddenTag = false;
    hiddenPages.map((item: any) => {
      if (window.location.pathname.includes(item)) {
        isHiddenTag = true;
      }
    });
    setIsHidden(isHiddenTag);
  }, [hiddenPages]);

  return (
    <IconStyle>
      <div
        style={{
          display: isHidden ? 'none' : 'inline-block',
          zIndex: '1000',
        }}
      >
        {!isHidden ? (
          <span
            ref={dragRef}
            className="img-container"
            onClick={() => {
              // window.open('/aiChat', '_blank');
              const env = getEnv();
              if (env !== 'prod') {
                window.open(`//aichat-${getEnv()}.ywwl.com/aiChat?token=${window.localStorage.getItem('token')}`, '_blank');
              } else {
                window.open(`//aichat.ywwl.com/aiChat?token=${window.localStorage.getItem('token')}`, '_blank');
              }
            }}
          >
            <img
              style={{
                width: '90px',
                objectFit: 'cover',
              }}
              src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/broadcast/liveAuthorManage/遥望AIOS_00000_iSpt.webp"
              alt=""
            />
          </span>
        ) : null}
        {isDragging ? (
          <div
            className="drap-content"
            ref={dropMoveRef}
            style={{
              position: 'fixed',
              top: '0',
              right: '0',
              width: '90px',
              height: '100vh',
            }}
          />
        ) : null}
      </div>
    </IconStyle>
  );
}

export default AiChatExit;
